import { HttpUrlEncodingCodec } from '@angular/common/http';

export default class CustomURIEncoder extends HttpUrlEncodingCodec {
  override encodeKey(key: string): string {
    return encodeURIComponent(key);
  }

  override encodeValue(value: string): string {
    return encodeURIComponent(value);
  }
}
